import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { DownIcon, InfoIcon } from '../../assets/common-svg/CommonSvg';
import {  useEffect, useState } from 'react';

export default function CustomAccordion({
  rootDivClass,
  accordionClassName,
  backgroundColor,
  index,
  color,
  leftBorder,
  type,
  expanded,
  handleExpansion,
  style,
  title,
  status,
  children,
  noBorderDetail,
  disabled=false,
  chip
}) {
const [isExpanded, setIsExpanded] = useState(false); // Start closed

const handleExpansionCustom = (panelIndex) => {
  setIsExpanded(!isExpanded);
  handleExpansion(panelIndex)
};

useEffect(()=> {
 setIsExpanded(expanded);
},[expanded])

  return (
    <div className={rootDivClass} style={style}>
      <Accordion
        className={accordionClassName}
        expanded={isExpanded}
         onChange={() => !disabled && handleExpansionCustom(index)}
        sx={{
          style,
          borderLeft: leftBorder ? `4px solid ${color}` : "none",
        }}
        disableGutters square TransitionProps={{ unmountOnExit: false }}
      >
        <AccordionSummary
          sx={{ backgroundColor: backgroundColor }}
           expandIcon={!disabled && <DownIcon />} 
          aria-controls={`panel1-content${index}`}
          id={`panel1-header${index}`}
        >
          <Typography className='flex flex-col gap-2' >

           <div className="flex items-start gap-2">
              {/* Title section */}
              <Typography className="font-bold text-[0.9rem] flex-1">
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </Typography>
              
              {/* Chip section - only renders if chip exists */}
              {chip && (
                <div className="flex-shrink-0">
                  {chip}
                </div>
              )}
            </div>

            <p className='flex gap-2'>
             
              {status?.map((op, index) => (
                <span key={index} className='flex gap-3' style={{ color: op?.color }}>{op?.icon}{op?.text}</span>
              ))}
              {type == "draft" && <span className='flex gap-3 text-[#808080] ml-2' ><InfoIcon Height={20} Width={20} Filled="#808080" />{" Save as draft"}</span>}
            </p>
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={`${noBorderDetail? 'p-0':'border-t-2'} border-gray-200 max-h-[50vh] h-auto overflow-auto`} style={{ height: expanded ? 'auto' : 0, overflow: 'hidden' }} >
          <Typography>
            
            {children}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div >
  );
}
